import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';
import HeroSection from '../sections/HeroSection';
import SolutionsSection from '../sections/SolutionsSection';
import ProductsSection from '../sections/ProductsSection';
import ProjectsSection from '../sections/ProjectsSection';
import AboutSection from '../sections/AboutSection';

const Home = () => {
  return (
    <div className="min-h-screen bg-primary">
      <Header />
      <main>
        <HeroSection />
        <SolutionsSection />
        <ProductsSection />
        <ProjectsSection />
        <AboutSection />
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default Home;
